/**
 * Combat Audio Controller Type Definitions
 * @module services/sound/combat-audio-types
 */

/**
 * Combat event types that trigger audio
 */
export type AudioRelevantEventType =
  | 'attack_started'
  | 'damage_dealt'
  | 'projectile_spawned'
  | 'unit_died';

/**
 * Combat Audio Controller configuration
 */
export interface CombatAudioConfig {
  /** Master enable/disable for all combat audio */
  enabled: boolean;
  /** Play attack sounds on attack_started events */
  playAttackSounds: boolean;
  /** Play hit sounds on damage_dealt events */
  playHitSounds: boolean;
  /** Play projectile sounds on projectile events */
  playProjectileSounds: boolean;
  /** Play death sounds on unit_died events */
  playDeathSounds: boolean;
  /** Play spawn sounds when new units appear */
  playSpawnSounds: boolean;
}

/**
 * Default configuration - all sounds enabled
 */
export const DEFAULT_AUDIO_CONFIG: CombatAudioConfig = {
  enabled: true,
  playAttackSounds: true,
  playHitSounds: true,
  playProjectileSounds: true,
  playDeathSounds: true,
  playSpawnSounds: true,
};

/**
 * Processed event tracking for deduplication
 */
export interface ProcessedEvent {
  /** Unique ID for deduplication (tick + type + data hash) */
  eventId: string;
  /** Tick when event occurred */
  tick: number;
}
